<!--
 * @Author: your name
 * @Date: 2020-08-13 21:47:36
 * @LastEditTime: 2021-01-19 20:48:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/AmountPay/index.vue
-->
<style scoped lang="sass">
.amount_pay
  line-height:48px
  font-size: 15px
  color: rgba(51, 68, 85, 1)

  .money
    font-weight: 500
</style>

<template lang="pug">
.amount_pay
  span {{ t('amount_to_pay', 'Amount to pay:') }}
  span.money {{ defaultSymbolPosition === 'after' ? '' : defaultCurrencySymbol }}{{ totalPrice | fix }}{{ defaultSymbolPosition === 'after' ? ' ' + defaultCurrencySymbol : '' }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { formatDecimalNumber, getDefaultCurrencySymbol, getDefaultSymbolPosition } from '@/utils/currency'
import { t } from '@/utils/language'

@Component({
  filters: {
    fix(val) {
      if (typeof val === 'string') return val
      return val ? formatDecimalNumber(val) : 0
    }
  },
  props: {
    totalPrice: {
      type: [String, Number]
    }
  },
  computed: {
    defaultCurrencySymbol() {
      return getDefaultCurrencySymbol()
    },
    defaultSymbolPosition() {
      return getDefaultSymbolPosition()
    },
  }
})
class AmountPay extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }
}

export default AmountPay
</script>
